import { render, staticRenderFns } from "./nopermission.vue?vue&type=template&id=2868ae75&"
import script from "./nopermission.vue?vue&type=script&lang=js&"
export * from "./nopermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports